export function Button({ children, className = "", size = "md", ...props }) {
  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-5 py-3 text-lg",
  };

  return (
    <button
      className={`inline-flex items-center justify-center rounded-2xl font-medium shadow-sm transition-colors
                  bg-black text-white hover:bg-black/60 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                  disabled:opacity-50 disabled:pointer-events-none active:scale-95
                  ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}